import { format } from 'date-fns';

export enum DateFormat {
  /**
   * 14
   */
  DAY_OF_MONTH = 'd',
  /**
   * Tue
   */
  DAY_OF_WEEK = 'iii',
  /**
   * Eg: 28 Jun 2021, 12:40 pm
   */
  FULL_DATE_WITH_TIME = 'dd MMM yyyy, h:mmaaa',
  /**
   * Eg: 30/07/2021
   */
  FULL_DATE_SLASH_SEPARATED = 'dd/MM/yyyy',
  /**
   * Eg: 28 Jun 2021
   */
  FULL_DATE_SPACE_SEPARATED = 'dd MMM yyyy',
  /**
   * Eg: 28 06 2021
   */
  FULL_DATE_IN_NUMBER_SPACE_SEPERATED = 'dd MM yyyy',
  /**
   * Eg: 11 am
   */
  HOUR = 'h aa',
  /**
   * Eg: 11am
   */
  HOUR_OF_DAY = 'haa',
  /**
   * Eg: 2021-06-31
   */
  ISO_DATE = 'yyyy-MM-dd',

  /**
   * Eg: 2021-06
   */
  ISO_YEAR_AND_MONTH = 'yyyy-MM',
  /**
   * Eg: Jun 2020
   */
  MONTH_AND_YEAR = 'MMM yyyy',
  /**
   * Eg: 09 2020
   */
  MONTH_AND_YEAR_IN_NUMBER = 'MM yyyy',
  /**
   * Eg: Jun
   */
  MONTH = 'MMM',
  /**
   * Eg: Monday
   */
  Day = 'EEEE',
  /**
   * Eg: 11:30 am
   */
  TIME = 'h:mmaaa',
  /**
   * Eg: 23:30:45
   */
  TIME_IN_24_HOUR_FORMAT = 'k:mm:ss',
  /**
   * Eg: 2020
   */
  YEAR = 'yyyy',
}

export function formatDateTime(date: Date, formatString: DateFormat) {
  return format(date, formatString);
}
